// extracted by mini-css-extract-plugin
module.exports = {"root":"_012f47f4","telegram":"_b7cb9072","telegramIcon":"_28e387cd","textWrapper":"_a8d02a56","title":"_1813b0ae","caption":"_5dc8ae74"};